import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => {
	return {
		container: {
			maxWidth: 1440,
			width: '100%',
			padding: '40px 30px',
			[theme.breakpoints.down('md')]: {
				padding: '20px 30px'
			}
		}
	};
});
